<template>
  <div class="content-container">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>管理</el-breadcrumb-item>
      <el-breadcrumb-item>人员管理</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="panel mt-20">
      <el-button
        type="primary"
        size="small"
        icon="el-icon-plus"
        @click="addStaffVisible = true"
        v-permission="Auth.dealerUserNew"
        >新增人员</el-button
      >
      <el-table v-if="!isMobile()" :data="staffs" stripe style="width: 100%">
        <el-table-column prop="name" label="姓名"></el-table-column>
        <el-table-column
          prop="phone_number"
          label="手机号"
          align="center"
        ></el-table-column>
        <el-table-column label="角色" align="center">
          <template slot-scope="scope">
            {{ showRoles(scope.row.auth_roles) }}
          </template>
        </el-table-column>
        <!-- <el-table-column
          label="销售组"
          prop="group.name"
          align="center"
        ></el-table-column> -->
        <el-table-column align="center" label="操作" width="180">
          <template slot-scope="scope">
            <el-popconfirm
              :title="`确认${scope.row.status == 1 ? '禁用' : '启用'}吗`"
              @confirm="handleSwitchStatus(scope.$index, scope.row.id)"
              v-permission="Auth.dealerUserStatus"
            >
              <el-button
                slot="reference"
                :type="scope.row.status == 1 ? 'danger' : 'primary'"
                plain
                size="mini"
                >{{ scope.row.status == 1 ? '禁用' : '启用' }}</el-button
              >
            </el-popconfirm>
            <el-button
              class="ml-10"
              type="primary"
              plain
              size="mini"
              @click="handleEdit(scope.$index, scope.row)"
              v-permission="Auth.dealerUserEdit"
              >编辑</el-button
            >
            <!-- <el-button
                  style="color:#909399!important"
                  type="text"
                  size="small"
                  @click="discount(scope.row)"
                  >重置密码</el-button
            >-->
          </template>
        </el-table-column>
      </el-table>
      <ul v-else class="list-style">
        <li v-for="(staff, index) in staffs">
          <div class="flex-row-between">
            <span>{{ staff.name }}</span>
            <a :href="'tel:' + staff.phone_number">{{ staff.phone_number }}</a>
          </div>
          <div class="text-info-12">{{ showRoles(staff.auth_roles) }}</div>
          <div class="text-info-12">{{ staff.group.name }}</div>
          <div class="mt-10">
            <el-popconfirm
              class="mr-10"
              :title="`确认${staff.status == 1 ? '禁用' : '启用'}吗`"
              @confirm="handleSwitchStatus(index, staff.id)"
              v-permission="Auth.dealerUserStatus"
            >
              <el-button
                slot="reference"
                :type="staff.status == 1 ? 'danger' : 'primary'"
                plain
                size="mini"
                >{{ staff.status == 1 ? '禁用' : '启用' }}</el-button
              >
            </el-popconfirm>
            <el-button
              type="primary"
              plain
              size="mini"
              @click="handleEdit(scope.$index, scope.row)"
              v-permission="Auth.dealerUserNew"
              >编辑</el-button
            >
          </div>
        </li>
      </ul>
      <el-dialog
        :title="staffForm.id ? '编辑人员' : '新增人员'"
        :visible.sync="addStaffVisible"
        :close-on-click-modal="false"
        width="40%"
        @closed="resetForm('staffForm')"
      >
        <el-form
          :model="staffForm"
          :rules="rules"
          ref="staffForm"
          label-width="90px"
          size="small"
        >
          <el-form-item label="姓名" prop="name">
            <el-input v-model="staffForm.name" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="phone_number">
            <el-input
              v-model="staffForm.phone_number"
              autocomplete="off"
              maxlength="11"
            ></el-input>
          </el-form-item>
          <el-form-item label="角色" prop="roles">
            <el-select
              style="width: 100%"
              v-model="staffForm.roles"
              multiple
              placeholder="请选择职位"
            >
              <el-option
                v-for="(item, index) in roles"
                :key="item.id"
                :label="item.name"
                :value="parseInt(item.id)"
              ></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="销售组" prop="group_id">
            <el-select
              style="width: 100%"
              v-model="staffForm.group_id"
              filterable
              placeholder="请选择"
            >
              <el-option
                v-for="item in groups"
                :key="item.id"
                :label="item.name"
                :value="parseInt(item.id)"
              ></el-option>
            </el-select>
          </el-form-item> -->
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="addStaffVisible = false" size="small"
            >取 消</el-button
          >
          <el-button
            type="primary"
            @click="submitForm('staffForm')"
            size="small"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  userList,
  groupList,
  createUser,
  updateUser,
  switchUserStatus,
  roleList,
} from '../../service/getData'
import { clone } from '@/util'
import auth from '../../util/auth'
import { isMobile } from '@/util/index'

export default {
  watch: {},
  data() {
    return {
      isMobile,
      page: 0,
      size: 1000,
      staffForm: {
        id: 0,
        name: '',
        phone_number: '',
        roles: [],
        group_id: '',
      },
      auth,
      editIndex: 0,
      rules: {
        name: [
          { required: true, message: '请填写姓名', trigger: 'blur' },
          {
            min: 2,
            max: 15,
            message: '长度在 2 到 15 个字符',
            trigger: 'blur',
          },
        ],
        roles: [
          {
            type: 'array',
            required: true,
            message: '请至少选择一个角色',
            trigger: 'change',
          },
        ],
        phone_number: [
          {
            required: true,
            pattern: /^1\d{10}$/,
            message: '手机号错误',
            trigger: 'blur',
          },
        ],
      },
      staffs: [],
      roles: [],
      addStaffVisible: false,
      groups: [],
    }
  },
  created() {
    this.initData()
    this.getGroups()
    this.getRoles()
  },
  methods: {
    async initData() {
      let res = await userList({ page: this.page, size: this.size })
      if (res.code == 0) {
        this.staffs = res.data.list
      }
    },

    async getGroups() {
      let res = await groupList({ page: 0, size: 20000 })
      if (res.code == 0) {
        this.groups = res.data.list
      }
    },

    async getRoles() {
      let res = await roleList()
      if (res.code == 0) {
        this.roles = res.data.list.filter((item) => item.status == 1)
      }
    },

    showRoles(roles) {
      if (!roles) return ''

      let names = roles.map((item) => {
        return item.name
      })
      return names.join(' / ')
    },

    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          if (this.staffForm.group_id == '') {
            this.staffForm.group_id = 0
          }
          if (this.staffForm.id) {
            let res = await updateUser(this.staffForm)
            if (res.code == 0) {
              this.$set(this.staffs, this.editIndex, res.data)
              this.addStaffVisible = false
            }
          } else {
            let res = await createUser(this.staffForm)
            if (res.code == 0) {
              this.staffs.unshift(res.data)
              this.addStaffVisible = false
            }
          }
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.staffForm.id = 0
    },
    handleEdit(index, item) {
      let roles = item.auth_roles
        ? item.auth_roles.map((item) => {
            return item.id
          })
        : []

      this.addStaffVisible = true
      this.$nextTick(() => {
        this.staffForm = {
          id: item.id,
          name: item.name,
          phone_number: item.phone_number,
          roles: roles,
          group_id: item.group_id == 0 ? '' : item.group_id,
        }
        this.editIndex = index
      })
    },
    async handleSwitchStatus(index, id) {
      let res = await switchUserStatus(id)
      if (res.code == 0) {
        this.staffs[index].status = res.data.status
        this.$message({
          message: `操作成功`,
          type: 'success',
          center: true,
        })
      }
    },
  },
}
</script>

<style scoped>
.long {
  width: 100%;
}
</style>